module.exports = __webpack_public_path__ + "img/eleve.2e1816f6.svg";